export const SET_CORPORATION_COMMON_QUESTIONS = "SET_CORPORATION_COMMON_QUESTIONS"
export const SET_VENTURE_COMMON_QUESTIONS = "SET_VENTURE_COMMON_QUESTIONS"